import wallar1 from "../../images/wallart/wallart1.jpg";
import wallar2 from "../../images/wallart/wallart2.jpg";
import wallar3 from "../../images/wallart/wallart3.jpg";
import wallar4 from "../../images/wallart/wallart4.jpg";
import wallar5 from "../../images/wallart/wallart5.jpg";
import wallar6 from "../../images/wallart/wallart6.jpg";
import wallar7 from "../../images/wallart/wallart7.jpg";
import wallar8 from "../../images/wallart/wallart8.jpg";

const WallartProducts = [
  {
    image: wallar1,
    name: "Wall-Decor Minim",
    price: "$5.00 USD",
  },
  {
    image: wallar2,
    name: "Guitar Wall Art Poster",
    price: "$8.00 USD",
  },
  {
    image: wallar3,
    name: "Canvas Painting ",
    price: "$4.00 USD",
  },
  {
    image: wallar4,
    name: "Black White All Of Me Loves",
    price: "$11.00 USD",
  },
  {
    image: wallar5,
    name: "this is us Poster",
    price: "$8.00 USD",
  },
  {
    image: wallar6,
    name: "Couples words love",
    price: "$15.00 USD",
  },
  {
    image: wallar7,
    name: "Chines art wall",
    price: "$7.99 USD",
  },
  {
    image: wallar8,
    name: "Forest art wall paint",
    price: "$23.00 USD",
  },
];
export default WallartProducts;
